<template>
  <global-modal
    class="event-modal-detail-pass__wrap"
    name="event-modal-detail-pass"
    @before-open="beforeOpen"
  >
    <Modal back mini @close="$modal.hide('event-modal-detail-pass')">
      <div class="event-modal-detail-pass">
        <header class="event-modal-detail-pass-header">
          <div class="event-modal-detail-pass-header__container">
            <h1 class="event-modal-detail-pass-header__title">
              {{ $t("event.passes.montage.applicationTitle") }}
            </h1>
          </div>
        </header>
        <section class="event-modal-detail-pass-form">
          <div class="event-modal-detail-pass-form__wrapper">
            <EventModalPersonalPass :user="user" />
          </div>
        </section>
      </div>
    </Modal>
  </global-modal>
</template>

<script>
import Modal from "@/components/Modal/Modal.vue";
import EventModalPersonalPass from "@/components/Modal/Passes/EventModalPersonalPass.vue";

export default {
  name: "EventModalDetailPass",

  components: {
    Modal,
    EventModalPersonalPass
  },

  data() {
    return {
      user: {}
    };
  },
  methods: {
    beforeOpen(data) {
      this.user = data.params.user;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@v2/app/styles/mixins";
@import "@v2/app/styles/media";

.event-modal-detail-pass {
  min-height: calc(100 * var(--vh));
  background-color: rgba(249, 249, 249, 0.5);

  &__wrap {
    position: relative;
    z-index: 20;
  }
}

.event-modal-detail-pass-header {
  background: #fff;

  &__title {
    @include h1();
    color: rgba(0, 0, 0, 0.85);
  }
  &__container {
    box-sizing: border-box;
    width: 780px;
    padding: 55px 0 52px 80px;

    @include respond-down(lg) {
      width: 100%;
      padding: 40px 24px 44px 24px;
    }
    @include respond-down(md) {
      width: 100%;
      padding: 24px 16px 34px 16px;
    }
  }
}

.event-modal-detail-pass-form {
  border-top: 2px solid #f1f1f1;

  &__wrapper {
    box-sizing: border-box;
    width: 860px;
    padding: 42px 0 42px 80px;

    @include respond-down(lg) {
      width: 100%;
      max-width: 768px;
      padding: 38px 24px 0 24px;
      box-sizing: border-box;
    }

    @include respond-down(md) {
      width: 100%;
      padding: 30px 16px 0;
      box-sizing: border-box;
    }
  }
}
</style>
